<template>
  <div>
    <div class="row">&nbsp;</div>
    <div class="container-fluid">
      <div class="card">
        <div v-if="page_status === null" class="card-body">
          <div class="d-flex justify-content-center">
            loading...
          </div>
        </div>

        <div v-else-if="page_status === 'N'" class="card-body">
          <div class="d-flex justify-content-center">
            รายงานนี้ยังไม่เปิดให้เข้าถึง กรุณาติดต่อผู้จัดงาน
          </div>
        </div>

        <div v-else class="card-body p-0 realtime-body">
          <!-- Hero Header -->
          <div class="hero-header">
            <div class="hero-left">
              <h3 class="hero-title">{{ eventDetails.title || $route.params.event_key }}</h3>
              <div class="hero-sub">รายงานข้อมูลผู้สมัคร</div>
              <div class="hero-updated" v-if="lastUpdatedAt">
                <vue-feather type="clock" size="13"></vue-feather>
                อัปเดตล่าสุด {{ lastUpdatedAt }}
              </div>
            </div>
            <div class="hero-right">
              <div class="hero-actions">
                <button type="button" @click.prevent="load_additional1_report()" class="btn btn-primary btn-sm hero-refresh" :disabled="is_loading_report === 'Y'">
                  <vue-feather type="refresh-cw" size="15" :class="{ spinning: is_loading_report === 'Y' }"></vue-feather>
                  รีเฟรช
                </button>
                <button type="button" @click.prevent="download_additional1_excel()" class="btn btn-success btn-sm hero-refresh" :disabled="is_loading_excel === 'Y' || report_additional1.length === 0">
                  <vue-feather type="download" size="15" :class="{ spinning: is_loading_excel === 'Y' }"></vue-feather>
                  Download Excel
                </button>
              </div>
            </div>
          </div>

          <div class="realtime-content">
            <!-- Summary stats -->
            <div v-if="report_additional1.length > 0" class="summary-card">
              <div class="summary-stats">
                <div class="stat-block">
                  <div class="stat-icon bg-primary-soft"><vue-feather type="users" size="18"></vue-feather></div>
                  <div>
                    <div class="stat-num">{{ getTotalCount().toLocaleString() }}</div>
                    <div class="stat-label">ผู้สมัครทั้งหมด (PAID)</div>
                  </div>
                </div>
                <div class="stat-block">
                  <div class="stat-icon bg-secondary-soft"><vue-feather type="layers" size="18"></vue-feather></div>
                  <div>
                    <div class="stat-num">{{ report_additional1.length.toLocaleString() }}</div>
                    <div class="stat-label">จำนวนกลุ่ม</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading -->
            <div v-if="is_loading_report === 'Y' && report_additional1.length === 0" class="state-box">
              <div class="text-center">
                <img style="width: 60px" src="../../assets/images/running_loading.svg" />
                <div class="mt-3 text-muted">กำลังโหลดข้อมูล...</div>
              </div>
            </div>

            <template v-else-if="report_additional1.length > 0">
              <!-- Top 3 Podium -->
              <div class="section-title">
                <vue-feather type="award" size="18"></vue-feather>
                <span>อันดับสูงสุด Top 3</span>
              </div>
              <div class="podium-card">
                <div
                  v-for="p in getPodium()"
                  :key="'podium-' + p.rank"
                  class="podium-col"
                  :class="'podium-rank-' + p.rank"
                >
                  <div class="podium-medal">{{ p.medal }}</div>
                  <div class="podium-name" :title="p.item.additional1_name">{{ p.item.additional1_name }}</div>
                  <div class="podium-count">{{ Number(p.item.count_total || 0).toLocaleString() }} คน</div>
                  <div class="podium-percent">{{ getItemPercent(p.item).toFixed(2) }}%</div>
                  <div class="podium-base">
                    <span class="podium-base-no">{{ p.rank }}</span>
                  </div>
                </div>
              </div>

              <!-- Chart -->
              <div class="section-title mt-4">
                <vue-feather type="bar-chart-2" size="18"></vue-feather>
                <span>จำนวนผู้สมัคร</span>
              </div>
              <div class="chart-card">
                <div class="chart-wrap" :style="{ height: chartHeight + 'px' }">
                  <canvas ref="additional1Chart"></canvas>
                </div>
              </div>

              <!-- Ranked list -->
              <div class="section-title mt-4">
                <vue-feather type="list" size="18"></vue-feather>
                <span>จำนวนผู้สมัคร (%)</span>
              </div>
              <div class="rank-card">
                <div v-for="(item, index) in report_additional1" :key="item.additional1_name" class="rank-row" :class="{ 'rank-row-top': index < 3 }">
                  <div v-if="index < 3" class="rank-no rank-no-medal">{{ getMedal(index + 1) }}</div>
                  <div v-else class="rank-no" :style="{ background: getChartColor(index) }">{{ index + 1 }}</div>
                  <div class="rank-info">
                    <div class="rank-head">
                      <div class="rank-name" :title="item.additional1_name">{{ item.additional1_name }}</div>
                      <div class="rank-count">
                        <b>{{ Number(item.count_total || 0).toLocaleString() }}</b> คน
                        <span class="rank-percent">({{ getItemPercent(item).toFixed(2) }}%)</span>
                      </div>
                    </div>
                    <div class="rank-progress">
                      <div
                        class="rank-progress-bar"
                        :style="{ width: getItemPercent(item) + '%', background: getChartColor(index) }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- Empty -->
            <div v-else class="state-box">
              <div class="text-center text-muted">
                <vue-feather type="inbox" size="48" class="mb-3"></vue-feather>
                <div>ไม่พบข้อมูลผู้สมัคร</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { markRaw } from "vue";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, BarController, CategoryScale, LinearScale);

export default {
  data() {
    return {
      page_status: null,
      eventDetails: {},
      is_loading_report: "N",
      is_loading_excel: "N",
      report_additional1: [],
      lastUpdatedAt: "",
      additional1Chart: null,
      chartColors: [
        "#4f46e5", "#06b6d4", "#22c55e", "#f59e0b", "#ef4444",
        "#8b5cf6", "#0ea5e9", "#10b981", "#f97316", "#ec4899",
        "#6366f1", "#14b8a6", "#84cc16", "#eab308", "#dc2626",
      ],
    };
  },
  computed: {
    chartHeight() {
      return Math.max(300, this.report_additional1.length * 38 + 60);
    },
  },
  async mounted() {
    await this.getEventDetail(this.$route.params.event_key);
    if (this.eventDetails.is_enable_addtional_report !== "Y") {
      this.page_status = "N";
      return;
    }
    this.page_status = "Y";
    await this.load_additional1_report();
  },
  beforeDestroy() {
    this.destroyChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/initial/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data.body[0] || {};
      }
    },
    async load_additional1_report() {
      if (this.is_loading_report === "Y") {
        return;
      }
      this.is_loading_report = "Y";
      const data = {
        event_key: this.$route.params.event_key,
      };

      const res = await axios.post("v1/organizer/report-additional1-realtime", data);

      if (res.data.status === "success") {
        this.report_additional1 = res.data.body || [];
        this.lastUpdatedAt = new Date().toLocaleString("th-TH");
        this.$nextTick(() => {
          this.createChart();
        });
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: load_additional1_report");
      }

      this.is_loading_report = "N";
    },
    async download_additional1_excel() {
      this.is_loading_excel = "Y";
      const data = {
        event_key: this.$route.params.event_key,
      };

      try {
        const response = await axios({
          url: "v1/organizer/report-additional1-excel",
          method: "POST",
          data: data,
          responseType: "blob",
        });

        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        const dt = new Date();
        const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
        const txt_file = dt.getFullYear() + padL(dt.getMonth() + 1) + padL(dt.getDate()) + padL(dt.getHours()) + padL(dt.getMinutes());

        const excel_report_file_name = "[รายงานข้อมูลผู้สมัคร]" + this.$route.params.event_key + "-" + txt_file + ".xlsx";
        link.setAttribute("download", excel_report_file_name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } catch (error) {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: download_additional1_excel");
      }

      this.is_loading_excel = "N";
    },
    destroyChart() {
      if (this.additional1Chart) {
        this.additional1Chart.destroy();
        this.additional1Chart = null;
      }
    },
    createChart() {
      if (!this.$refs.additional1Chart) {
        return;
      }

      this.destroyChart();

      try {
        // กันกรณีมี chart เก่าค้างอยู่บน canvas เดิม
        const existing = ChartJS.getChart(this.$refs.additional1Chart);
        if (existing) {
          existing.destroy();
        }

        const ctx = this.$refs.additional1Chart.getContext("2d");
        const total = this.getTotalCount();

        const labels = this.report_additional1.map((item) => item.additional1_name);
        const data = this.report_additional1.map((item) => parseInt(item.count_total || 0));
        const colors = this.report_additional1.map((_, index) => this.getChartColor(index));

        // markRaw กัน Vue ห่อ instance เป็น reactive Proxy ซึ่งทำให้ chart.js destroy ไม่สมบูรณ์
        this.additional1Chart = markRaw(new ChartJS(ctx, {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                label: "จำนวนผู้สมัคร (คน)",
                data: data,
                backgroundColor: colors,
                borderRadius: 6,
                maxBarThickness: 28,
              },
            ],
          },
          options: {
            indexAxis: "y",
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const value = context.parsed.x;
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : "0.00";
                    return `${value.toLocaleString()} คน (${percentage}%)`;
                  },
                },
                backgroundColor: "rgba(26, 32, 44, 0.95)",
                cornerRadius: 10,
                padding: 12,
                titleFont: {
                  size: 14,
                  weight: "bold",
                  family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif',
                },
                bodyFont: {
                  size: 13,
                  family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif',
                },
              },
            },
            scales: {
              x: {
                beginAtZero: true,
                ticks: {
                  precision: 0,
                  font: {
                    family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif',
                  },
                },
                grid: {
                  color: "#eef0f5",
                },
              },
              y: {
                ticks: {
                  autoSkip: false,
                  font: {
                    size: 12,
                    family: '"Segoe UI", Arial, "Noto Sans Thai", sans-serif',
                  },
                  callback: function (value) {
                    const label = this.getLabelForValue(value);
                    return label.length > 30 ? label.substring(0, 30) + "..." : label;
                  },
                },
                grid: {
                  display: false,
                },
              },
            },
            animation: {
              duration: 800,
              easing: "easeOutQuart",
            },
          },
        }));
      } catch (error) {
        console.error("Error creating chart:", error);
      }
    },
    getChartColor(index) {
      return this.chartColors[index % this.chartColors.length];
    },
    getTotalCount() {
      return this.report_additional1.reduce((total, item) => total + parseInt(item.count_total || 0), 0);
    },
    getItemPercent(item) {
      const total = this.getTotalCount();
      if (total <= 0) return 0;
      return Math.round((parseInt(item.count_total || 0) / total) * 10000) / 100;
    },
    getMedal(rank) {
      if (rank === 1) return "🥇";
      if (rank === 2) return "🥈";
      if (rank === 3) return "🥉";
      return rank;
    },
    getPodium() {
      // เรียงแบบ podium: ที่ 2 ซ้าย, ที่ 1 กลาง, ที่ 3 ขวา
      const top3 = this.report_additional1.slice(0, 3).map((item, i) => ({
        rank: i + 1,
        medal: this.getMedal(i + 1),
        item: item,
      }));
      if (top3.length === 3) return [top3[1], top3[0], top3[2]];
      if (top3.length === 2) return [top3[1], top3[0]];
      return top3;
    },
  },
};
</script>

<style scoped>
.realtime-body {
  background: #f7f8fc;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid #eceef4;
}

/* ===== Hero Header ===== */
.hero-header {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 24px 30px;
  background: #fff;
  color: #1f2937;
  border-bottom: 1px solid #eef0f5;
}

.hero-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #4f46e5, #06b6d4);
}

.hero-left {
  position: relative;
  z-index: 1;
}

.hero-title {
  font-size: 25px;
  font-weight: 800;
  margin: 0;
  line-height: 1.2;
  color: #111827;
  letter-spacing: -0.3px;
}

.hero-sub {
  font-size: 14px;
  color: #6b7280;
  margin-top: 4px;
}

.hero-updated {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 10px;
}

.hero-right {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hero-refresh {
  font-weight: 600;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.spinning {
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== Content ===== */
.realtime-content {
  padding: 24px 30px 30px;
}

/* ===== Summary card ===== */
.summary-card {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
  background: #fff;
  border-radius: 18px;
  padding: 26px 32px;
  border: 1px solid #eef0f5;
  box-shadow: 0 10px 30px rgba(17, 24, 39, 0.05);
  margin-bottom: 26px;
}

.summary-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 26px;
  flex: 1;
}

.stat-block {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bg-primary-soft { background: #eef2ff; color: #4f46e5; }
.bg-secondary-soft { background: #f1f5f9; color: #64748b; }

.stat-num {
  font-size: 24px;
  font-weight: 800;
  color: #111827;
  line-height: 1.1;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
}

/* ===== Section title ===== */
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 16px;
}

.section-title .feather {
  color: #7c3aed;
}

/* ===== Chart card ===== */
.chart-card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #eef0f5;
  box-shadow: 0 4px 16px rgba(17, 24, 39, 0.04);
  padding: 20px 22px;
}

.chart-wrap {
  position: relative;
  width: 100%;
}

/* ===== Podium Top 3 ===== */
.podium-card {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 18px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #eef0f5;
  box-shadow: 0 4px 16px rgba(17, 24, 39, 0.04);
  padding: 26px 22px 22px;
  margin-bottom: 10px;
}

.podium-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 200px;
  max-width: 32%;
}

.podium-medal {
  font-size: 34px;
  line-height: 1;
  margin-bottom: 8px;
}

.podium-rank-1 .podium-medal {
  font-size: 46px;
}

.podium-name {
  font-size: 13.5px;
  font-weight: 700;
  color: #1f2937;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.podium-rank-1 .podium-name {
  font-size: 15px;
}

.podium-count {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
  margin-top: 3px;
}

.podium-rank-1 .podium-count {
  font-size: 22px;
}

.podium-percent {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 10px;
}

.podium-base {
  width: 100%;
  border-radius: 10px 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.podium-rank-1 .podium-base {
  height: 86px;
  background: linear-gradient(180deg, #fbbf24, #f59e0b);
}

.podium-rank-2 .podium-base {
  height: 60px;
  background: linear-gradient(180deg, #d1d5db, #9ca3af);
}

.podium-rank-3 .podium-base {
  height: 44px;
  background: linear-gradient(180deg, #fdba74, #ea580c);
}

.podium-base-no {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* ===== Ranked list ===== */
.rank-card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #eef0f5;
  box-shadow: 0 4px 16px rgba(17, 24, 39, 0.04);
  padding: 8px 22px;
}

.rank-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f1f3f8;
}

.rank-row:last-child {
  border-bottom: none;
}

.rank-no {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rank-no-medal {
  background: transparent !important;
  font-size: 22px;
}

.rank-row-top .rank-name {
  font-weight: 700;
}

.rank-info {
  flex: 1;
  min-width: 0;
}

.rank-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 7px;
}

.rank-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rank-count {
  flex-shrink: 0;
  font-size: 14px;
  color: #111827;
}

.rank-percent {
  font-size: 12px;
  color: #6b7280;
}

.rank-progress {
  height: 8px;
  background: #eef0f5;
  border-radius: 20px;
  overflow: hidden;
}

.rank-progress-bar {
  height: 100%;
  border-radius: 20px;
  transition: width 0.7s ease;
}

/* ===== State boxes ===== */
.state-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 3px 14px rgba(17, 24, 39, 0.05);
}

@media (max-width: 575px) {
  .hero-header,
  .realtime-content {
    padding-left: 16px;
    padding-right: 16px;
  }
  .hero-right {
    align-items: flex-start;
  }
}
</style>
